import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { SwiperComponent, SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { ContactService } from '../../services/contact.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { WantedItem } from '../../models/wanted-item.model';

@Component({
  selector: 'app-cars-wanted-teaser',
  templateUrl: './cars-wanted-teaser.component.html'
})
export class CarsWantedTeaserComponent implements OnInit {

  @Input() data: WantedItem;

  public swiperConfig: SwiperConfigInterface = {
    direction: 'horizontal',
    init: true,
    slidesPerView: 1,
    effect: 'fade'
  };

  swiperIndex = 0;

  @ViewChild('swiper', { static: true }) swiper: SwiperComponent;

  constructor(private router: Router, private contactService: ContactService, private translate: TranslateService) {
  }

  ngOnInit() {
  }

  prevImg() {
    if (this.swiperIndex > 0) {
      this.swiperIndex -= 1;
    }
  }

  nextImg() {
    if (this.swiperIndex + 1 < this.data.images.length) {
      this.swiperIndex += 1;
    }
  }

  requestCarsWanted() {
    this.contactService.carWanted = this.data;
    this.router.navigate(['/contact/cars-wanted', this.data.id]).then();
  }

}
